import React, { useEffect } from 'react'
import _ from 'lodash'
import { FormikErrors as IFormikErrors, useFormikContext } from 'formik'
import { ErrorType } from '../../../generated/gqlTypes'
import { camelize } from '../../utils/misc'

interface FormikErrorsProps {
  errors: IFormikErrors<any> | ErrorType[] | { messages: string[]; field?: string }[] | null
}

const FormikErrors: React.FC<FormikErrorsProps> = ({ errors }) => {
  const { setErrors } = useFormikContext()
  useEffect(() => {
    if (errors) {
      if (_.isArray(errors)) {
        const obj = {}
        errors.forEach(err => {
          obj[camelize(err.field)] = err.messages.join('.')
        })
        setErrors(obj)
      } else {
        setErrors(errors)
      }
    }
  }, [errors])
  return null
}

export default FormikErrors
